import axios from 'axios';
import { API_BASE_URL } from '@/config/api';

const USERS_URL = `${API_BASE_URL}/users`;

export async function getEligibleRestaurantManagers() {
  const { data } = await axios.get(
    `${USERS_URL}/eligible-restaurant-managers`,
    { withCredentials: true }
  );
  return data;
}

export async function assignRestaurantManager(userId, restaurantId) {
  const { data } = await axios.put(
    `${USERS_URL}/${encodeURIComponent(userId)}/restaurant-assignment`,
    { restaurant_id: restaurantId },
    { withCredentials: true }
  );
  return data;
}
